import React from "react";

import { SvgIcon } from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";

const LivePlayIcon = () => {
  return (
    <>
      <SvgIcon
        component={PlayArrowIcon}
        className="px-0 mx-0"
        style={styles.playIcon}
        sx={{ height: 18 }}
      />
    </>
  );
};

export default LivePlayIcon;

const styles = {
  playIcon: {
    color: "#04bd19",
  },
} as const;
